import { z } from 'zod';
export const roleSchema = z.enum(['ADMIN', 'MEMBER', 'VIEWER']);
export const meetingTypeSchema = z.enum([
    'CLIENT',
    'SUPPLIER',
    'INTERNAL',
    'MANAGEMENT',
    'ONLINE',
    'GENERIC',
]);
export const meetingStatusSchema = z.enum([
    'RECORDING',
    'UPLOADED',
    'TRANSCRIBING',
    'DRAFTING',
    'IN_REVIEW',
    'FINAL',
    'ARCHIVED',
    'FAILED',
    'NO_SPEECH',
]);
export const meetingLanguageSchema = z.enum(['AR', 'EN', 'BOTH']);
export const meetingSourceSchema = z.enum(['IN_PERSON', 'UPLOAD', 'ZOOM']);
export const uploadStateSchema = z.enum(['OPEN', 'COMPLETE', 'FAILED']);
export const vocabularyCategorySchema = z.enum([
    'CLIENT',
    'STAFF',
    'MATERIAL',
    'TECHNIQUE',
    'PRODUCT',
    'OTHER',
]);
export const transcriptionProviderSchema = z.enum(['elevenlabs', 'deepgram', 'zoom']);
//# sourceMappingURL=enums.js.map